import React from "react";
import QrCode from "../../../components/QrCode";
import OrderDetailTable from "./OrderDetailTable";
import { downloadAllOrderDetails } from "../../../redux/Orders/ordersActions";
import {
  Slide,
  Button,
  Grid,
  Dialog,
  Typography,
  IconButton,
  DialogContent,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Fade,
  LinearProgress,
} from "@material-ui/core";
import { VisibilityOutlined } from "@material-ui/icons";
import { connect } from "react-redux";
import Store from "../../../redux/Store";
import {
  set_Current_Order,
  set_Let_Refresh,
  set_Refresh,
} from "../../../redux/Orders/OrderActionCreators";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function OrderDetails(props) {
  const { rowValue, orderId, position, Load_Downoad, modal_loading } = props;
  const [open, setOpen] = React.useState(false);

  const handleCloseDialog = () => {
    setOpen(false);
    Store.dispatch(set_Refresh(0));
    Store.dispatch(set_Current_Order(""));

    Store.dispatch(set_Let_Refresh(true));
  };
  const handleClickOpen = () => {
    setOpen(true);
    Store.dispatch(set_Let_Refresh(false));
  };

  return (
    <>
      <IconButton
        color="primary"
        onClick={(e) => {
          e.stopPropagation();
          handleClickOpen();
        }}
        onFocus={(e) => e.stopPropagation()}
      >
        {position === "number" ? (
          <Typography variant="subtitle2">{rowValue}</Typography>
        ) : (
          <VisibilityOutlined fontSize="small" color="primary" />
        )}
      </IconButton>
      <Dialog
        BackdropProps={{
          style: {
            backdropFilter: "blur(1.2px)",
          },
        }}
        maxWidth="lg"
        fullWidth={true}
        open={open}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        onClick={(e) => e.stopPropagation()}
      >
        <DialogContent>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="subtitle2" color="secondary">
              شماره سفارش : {rowValue}
            </Typography>

            <Button
              disabled={Load_Downoad.all ? true : false}
              onClick={() => {
                downloadAllOrderDetails(orderId, rowValue);
              }}
              color="primary"
              variant="outlined"
            >
              دانلود همه
            </Button>

            <Grid item xs={12} style={{}}>
              <Fade in={modal_loading} mountOnEnter>
                <LinearProgress />
              </Fade>
              <OrderDetailTable rowValue={rowValue} orderId={orderId} />
            </Grid>
          </Grid>
          <Grid item sm={12}>
            <Typography variant="h6">انصراف از عملیات</Typography>
          </Grid>
          <form>
            <Grid
              item
              xs={12}
              container
              spacing={2}
              direction="row"
              justifyContent="space-between"
              style={{ boxShadow: "0 0 2px #333", margin: "auto" }}
            >
              <Grid item xs={4}>
                <TextField
                  variant="outlined"
                  color="primary"
                  placeholder="یادداشت خصوصی..."
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth size="small" color="primary">
                  <Select defaultValue="" color="primary" variant="outlined">
                    <MenuItem value="asad">خرابی دستگاه</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth size="small" color="primary">
                  <Select defaultValue="" color="primary" variant="outlined">
                    <MenuItem value="asd">aad</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <Button
                  onClick={(e) => e.preventDefault()}
                  disabled
                  color="primary"
                  variant="contained"
                  fullWidth
                  type="submit"
                >
                  ارسال
                </Button>
              </Grid>
            </Grid>
          </form>
          <br />
          <Grid item container xs={12} justifyContent="flex-end">
            <QrCode orderId={orderId} rowValue={rowValue} />
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}

const mapStateToProps = (props) => {
  const { OrderReducer } = props;
  const { refresh, qrCode, Load_Downoad, modal_loading } = OrderReducer;
  return { refresh, qrCode, Load_Downoad, modal_loading };
};

export default connect(mapStateToProps)(OrderDetails);
